import { ERRORS_MESSAGE, THUMBNAIL_SIZE_LIST } from "@lhd/constants";
import { Checkbox, Form, Input, Select } from "antd";
import { FC } from "react";

type PropsType = {
  getFieldClassName?: (name: string) => string;
};

const AttachmentEditModal: FC<PropsType> = ({ getFieldClassName }) => {
  return (
    <>
      <Form.Item
        name="name"
        label="フィールド名"
        rules={[{ required: true }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_required_field">
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item name="thumbnail_size" label="サムネイルのサイズ (ピクセル)">
        <Select options={THUMBNAIL_SIZE_LIST} />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default AttachmentEditModal;
